import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SoecoButton } from "../../components/SoecoButton";

type Props = {
    currentCompanyId: string;
};

export const ManageUsersActions = (props: Props) => {
    const navigate = useNavigate();
    const handleCreateUser = (idToNavigate: string) => {
        navigate(`/companies/${idToNavigate}/createUser`);
    };

    return (
        <ActionButtons>
            <SoecoButton fullWidth size="large" color="warning" onClick={() => navigate("/admin")}>
                Back
            </SoecoButton>
            <SoecoButton
                fullWidth
                size="large"
                color="primary"
                onClick={() => handleCreateUser(props.currentCompanyId)}
            >
                Create
            </SoecoButton>
        </ActionButtons>
    );
};

const ActionButtons = styled.div`
    display: flex;
    width: 95%;
    gap: 2rem;
    position: fixed;
    bottom: 2rem;
`;
